import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProductSettingsEffects } from './effects/product.effects';
import { productsReducer } from './reducer/products.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('products', productsReducer),
        EffectsModule.forFeature([ProductSettingsEffects]),
    ],
})
export class ProductsModule {}
